<script lang="ts"> 
    import { Card, Col, Image, Row } from 'sveltestrap';
    import { Rightsidedata } from '../../../../Data/Miscellaneous/Blog';
    import Link from 'svelte-link';
    import { href } from '../../../../utils/Constant/Constant';
    let imgPath:string = "/assets/images"
</script>
  
<Col xxl="6" class="set-col-12 box-col-12 xl-60">
    <Row>
        {#each Rightsidedata as elem}
            <Col xl="12" md="6">
                <Card>
                    <Row class="blog-box blog-list">
                        <Col xl="6" xs="12">
                            <div class="blog-wrraper">
                                <Link href={href}>
                                    <Image fluid class="sm-100-wp p-0" src="{imgPath}/{elem.img}" />
                                </Link>
                            </div>
                        </Col>
                        <Col xl="6" xs="12">
                            <div class="blog-details">
                                <div class="blog-date">
                                    <span>{elem?.date?.split(' ')[0]}</span> {elem?.date?.split(' ').splice(1, 2).join(' ')}
                                </div>
                                <h6>{elem.details}</h6>
                                <div class="blog-bottom-content">
                                    <ul class="blog-social"> 
                                        <li>{elem.admin}</li> 
                                        <li>{elem.hits}</li>
                                    </ul> 
                                    <hr />
                                    <p class="mt-0">{`inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit.`}</p>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Card>
            </Col>
        {/each}
    </Row>
</Col>
  